import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
  FinancialEntityBranchesFailure,
  FinancialEntityBranchesRequest,
  FinancialEntityBranchesSuccess,
} from './actions';
import { FinancialEntityBranchesService } from './service';

@Injectable()
export class FinancialEntityBranchesEffects {
  private readonly actions$ = inject(Actions);
  private readonly financialEntityBranchesService = inject(FinancialEntityBranchesService);

  financialEntityBranches$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FinancialEntityBranchesRequest),
      switchMap(({ parameters }) =>
        this.financialEntityBranchesService.financialEntityBranches(parameters).pipe(
          map(data => FinancialEntityBranchesSuccess({ data })),
          catchError(error => of(FinancialEntityBranchesFailure({ error })))
        )
      )
    )
  );

}
